var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"label":"","small":"","color":_vm.color,"text-color":_vm.textColor}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }